<template>
  <div>
    <HeroSection
      :title="$c.text('pages.career-track-certificate.heroTitle')"
      :subtitle="$c.text('pages.career-track-certificate.heroSubtitle')"
      :button-title="$c.text($config.platform === 'ds' ? 'button.start-today' : 'button.get-started')"
      button-link="/signup/"
      :image-url="heroImageFirst"
      class-name="right-shadow career-track-certificates"
      data-event="start_your_career_1.click"
    />

    <div class="col-12">
      <div class="site-section tracking-section first-section" data-event="certificate_achievement.scroll">
        <div class="container">
          <div class="text-center" :class="{ 'offset-2 col-8 col': $store.state.layout === 'desktop' }">
            <h2>
              {{ $c.text('pages.career-track-certificate.firstAnimation.title') }}
            </h2>
            <p class="body-1" :class="{ 'col': $store.state.layout === 'desktop' }">
              {{ $c.text('pages.career-track-certificate.firstAnimation.description') }}
            </p>
          </div>
          <div class="col-10 offset-1 first-animation">
            <Animation :options="{ data: animationCertificateAchievement, rendererSettings: { viewBoxOnly: true } }" />
          </div>
        </div>
      </div>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <div class="site-section tracking-section" data-event="apply_for_the_job.scroll">
          <div class="container">
            <div class="offset-1 col-10">
              <div class="row">
                <div class="col-5 col vertical-align">
                  <div class="col-12">
                    <h2>{{ $c.text('pages.career-track-certificate.secondAnimation.title') }}</h2>
                    <div class="body-1">
                      <p>
                        {{ $c.text('pages.career-track-certificate.secondAnimation.firstDescription') }}
                      </p>
                      <p>
                        {{ $c.text('pages.career-track-certificate.secondAnimation.secondDescription') }}
                      </p>
                      <ButtonArrow :text="$c.text('pages.career-track-certificate.buttonArrow')" type="nuxt-link" to="/signup/" />
                    </div>
                  </div>
                </div>
                <div class="col-1 col" />
                <div class="col-6 second-animation ">
                  <Animation :options="{ data: animationJobPlatform }" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Lazy>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <div class="site-section tracking-section" data-event="comparative_table.scroll">
          <div class="container">
            <div class="text-center" :class="$config.platform === 'ds' ? 'offset-3 col-6' : 'col-10 offset-1'">
              <h2>
                <template v-if="$config.platform === 'fa'">
                  {{ $c.text('pages.career-track-certificate.table.pre-title') }}
                  <br>
                </template>
                {{ $c.text('pages.career-track-certificate.table.title') }}
              </h2>
            </div>
            <div class="offset-1 col-10 text-center table-holder">
              <div class="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <td />
                      <td>
                        <Logo365Colored v-if="$config.platform === 'ds'" />
                        <span v-else>{{ $config.platformName }}</span>
                      </td>
                      <td v-html="$c.text('pages.career-track-certificate.table.tr1.td2')" />
                      <td>{{ $c.text('pages.career-track-certificate.table.tr1.td3') }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr2.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr2.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr2.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr2.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr3.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr3.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr3.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr3.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr4.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr4.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr4.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr4.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr5.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr5.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr5.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr5.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr6.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr6.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr6.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr6.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr7.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr7.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr7.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr7.td4') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr8.td1') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr8.td2') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr8.td3') }}</td>
                      <td>{{ $c.text('pages.career-track-certificate.table.tr8.td4') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Lazy>
      <Lazy never>
        <div class="site-section dark dot-animations tracking-section" data-event="how_to_get_career_track_certificate.scroll">
          <div class="container">
            <div class="offset-3 col-6 text-center">
              <h2>{{ $c.text('pages.career-track-certificate.steps.title') }}</h2>
            </div>
          </div>
          <div class="container">
            <div class="track-line">
              <div class="track-line-filler" />
            </div>
            <div class="tracker">
              <div v-for="k in 5" :key="k" class="col-12">
                <div class="col-6 sm-6">
                  <div class="col-8 sm-9 sm-offset-1 offset-2 col track">
                    <div class="h3">
                      {{ $c.text(`pages.career-track-certificate.steps.number${k}`) }}
                    </div>
                    <div>
                      <span class="h5">{{ $c.text(`pages.career-track-certificate.steps.title${k}`) }}</span> <br>
                      <span class="body-1">{{ $c.text(`pages.career-track-certificate.steps.text${k}`) }}</span>
                    </div>
                  </div>
                  <div class="track-dot" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-center container">
            <nuxt-link to="/signup/" class="btn-primary btn-lg track-button" data-event="receive_certificate.click">
              {{ $c.text('pages.career-track-certificate.steps.finish') }}
            </nuxt-link>
          </div>
        </div>
      </Lazy>
      <Lazy never>
        <div class="tracking-section physical-certificate-section" data-event="physical_certificate.scroll">
          <HeroSection
            :title="$c.text('pages.career-track-certificate.heroTitle2')"
            :subtitle="$c.text('pages.career-track-certificate.heroSubtitle2')"
            :button-title="$c.text('pages.career-track-certificate.heroButton2')"
            button-link="/signup/"
            data-event="request_certificate.click"
            :offset="1"
            inner-position
            :image-url="heroImageSecond"
            title-h2
            class="physical-hero"
            class-name="career-track-certificates"
          />
        </div>
      </Lazy>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <div class="site-section slider-wrap tracking-section slider" data-event="choose_career_track.scroll">
          <SliderTracks
            class="tracks"
            dark-theme
            :title="$c.text('pages.career-track-certificate.sliderTracksTitle')"
          />
        </div>
      </Lazy>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <div class="fa-background">
          <div class="container fa-faq">
            <div class="site-section tracking-section" data-event="faq.scroll">
              <FrequentlyAskedQuestions group="certificates" />
            </div>
          </div>
        </div>
      </Lazy>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <div>
          <StartLearningToday class="start-learn-today tracking-section" data-event="start_learning_today.scroll">
            <h2>
              {{ $c.text('component.start-learning-today.title') }}
            </h2>
            <p class="body-1">
              {{ $c.text('component.start-learning-today.description') }}
            </p>
            <ul>
              <li class="body-1">
                {{ $c.text('component.start-learning-today.li1') }}
              </li>
              <li class="body-1">
                {{ $c.text('component.start-learning-today.li2') }}
              </li>
              <li class="body-1">
                {{ $c.text('component.start-learning-today.li3') }}
              </li>
              <li class="body-1">
                {{ $c.text('component.start-learning-today.li4') }}
              </li>
            </ul>
          </StartLearningToday>
        </div>
      </Lazy>
      <Lazy :when-visible="{ rootMargin: '200px' }">
        <SignupForm
          v-if="$config.platform === 'fa'"
          title="Start Learning For Free"
          button-text="Start Your Career"
          button-class="btn-primary-yellow"
          type="signup"
          class="signup-form form-mobile"
          unique-id="first"
        />
      </Lazy>
    </div>
  </div>
</template>

<script>
import Lazy from 'vue-lazy-hydration';
import global from '@itbpbg/lms-components/src/mixins/global';
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import FrequentlyAskedQuestions from '@itbpbg/lms-components/src/FrequentlyAskedQuestions';
import SliderTracks from '../components/SliderTracks.vue';
import Animation from '../components/Animation';
import StartLearningToday from '../components/StartLearningToday.vue';
import Logo365Colored from '../assets/svg/365-logo-colored.svg?vue-component';
import SignupForm from '../components/SignupForm';

export default {
  components: {
    HeroSection,
    SliderTracks,
    FrequentlyAskedQuestions,
    Animation,
    ButtonArrow,
    StartLearningToday,
    Logo365Colored,
    Lazy,
    SignupForm,
  },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => false);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      page,
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [
        {
          vmid: 'jsonld',
          type: 'application/ld+json',
          json: [linkedData],
        },
      ],
    };
  },
  computed: {
    heroImageFirst() {
      if (this.$config.platform === 'fa') {
        return 'fa-career-certificate.jpg';
      }
      return 'career-certificate.jpg';
    },
    heroImageSecond() {
      if (this.$config.platform === 'fa') {
        return 'fa-get-a-physical-copy-of-your-certificate.jpg';
      }
      return 'get-a-physical-copy-of-your-certificate.jpg';
    },
    animationCertificateAchievement() {
      if (this.$config.platform === 'fa') {
        return 'fa/fa-a-certificate-of-achievement';
      }
      return 'a-certificate-of-achievement';
    },
    animationJobPlatform() {
      if (this.$config.platform === 'fa') {
        return 'fa/fa-acquire-the-necessary-skills-to-apply-for-the-job';
      }
      return 'acquire-the-necessary-skills-to-apply-for-the-job';
    },
  },
  mounted() {
    this.scrollAnimation();
    window.addEventListener('scroll', this.scrollAnimation);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', this.scrollAnimation));
  },
  methods: {
    scrollAnimation() {
      if (!this.$el.querySelector('.site-section.dark.dot-animations')) {
        return;
      }
      const dots = this.$el.querySelectorAll('.track-dot');
      const lineFiller = this.$el.querySelector('.track-line .track-line-filler');
      const button = this.$el.querySelector('.track-button');
      const buttonBound = button.getBoundingClientRect();
      const startPositionY = window.innerHeight * 0.5;

      if (lineFiller.getBoundingClientRect().y < startPositionY) {
        lineFiller.style.height = `${startPositionY - lineFiller.getBoundingClientRect().y}px`;
        dots.forEach((dot) => {
          const dotBound = dot.getBoundingClientRect();
          if (dotBound.top - startPositionY < 0) {
            dot.classList.add('filled');
          } else {
            dot.classList.remove('filled');
          }
        });
      } else {
        dots[0].classList.remove('filled');
        lineFiller.style.height = '0px';
      }

      if (buttonBound.y - startPositionY < 0) {
        button.classList.add('filled');
      } else {
        button.classList.remove('filled');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 0;
}

.vertical-align {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
}

.site-section:first-of-type {
  padding-top: var(--spacing-100);

  p {
    margin-bottom: 26px;

    @include bp($bp-phone) {
      margin-bottom: var(--spacing-80);
    }
  }

  @include bp($bp-desktop) {
    .container .text-center {
      margin: auto;
      float: none;

      .col {
        float: none;
      }
    }
  }
}

.site-section:nth-of-type(2) {
  p,
  h2 {
    margin-bottom: var(--spacing-36);
  }

  p:nth-of-type(2) {
    color: var(--main-dark-shade-3);
  }
}

.site-section:nth-of-type(3) {
  h2 {
    margin-bottom: var(--spacing-48);
  }
}

@include bp($bp-phone) {
  .site-section:first-of-type,
  .site-section:nth-of-type(2) {
    padding-bottom: 0;
  }

  .site-section:nth-of-type(2) {
    background-color: var(--main-light-shade-1);
  }
}

.site-section.slider-wrap {
  padding-top: var(--spacing-100);
}

.site-section.dark {
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-120);
  overflow: hidden;

  h2 {
    margin-bottom: var(--spacing-100);
  }
}

.table-wrap {
  overflow-x: auto;

  table {
    border-collapse: collapse;
    white-space: nowrap;
    margin: 0 auto var(--spacing-40);
    width: 100%;

    tr {
      td {
        padding: var(--spacing-24);

        &:nth-child(2) {
          background-color: var(--main-light-shade-1);
        }
      }

      &:first-child td:nth-child(2) {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      &:last-child td:nth-child(2) {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }

    thead {
      tr {
        font-size: 18px;
        font-weight: 500;
        line-height: 110%;
      }
    }

    tbody {
      tr {
        border-top: 1px solid var(--main-light-shade-3);

        td {
          font-size: 16px;
          line-height: 150%;

          &:first-of-type {
            font-weight: 500;
            text-align: left;
          }

          &:not(:first-of-type) {
            color: var(--main-dark-shade-3);
            font-weight: 400;
          }
        }
      }
    }
  }
}

.tracker {
  margin-bottom: 10px;
  padding-bottom: var(--spacing-80);

  > div {
    display: block;
    margin-top: -20px;
    overflow: hidden;
    padding-top: 7.5px;
    position: relative;

    .track-dot {
      background-color: var(--main-dark-shade-2);
      top: -7px;
      border-radius: 50%;
      content: '';
      display: block;
      height: 16px;
      position: absolute;
      width: 16px;
      transition: all var(--duration) ease-in;

      &.filled {
        background-color: var(--accent);
      }
    }

    > div {
      position: relative;
    }

    &:nth-child(even) {
      > div {
        float: right;

        .track-dot {
          left: -8px;
        }
      }
    }

    &:nth-child(odd) {
      > div {
        float: left;

        .track-dot {
          right: -8px;
        }
      }
    }

    .track {
      .h3 {
        margin: 0 0 var(--spacing-16);
        color: var(--accent);
      }

      span {
        color: var(--main-light-shade-3);
      }

      span.h5 {
        margin-bottom: 10px;
        display: inline-block;
      }
    }
  }

  @include bp($bp-phone) {
    margin-bottom: var(--spacing-48);
    padding-bottom: 0;

    > div {
      margin-top: 0;

      &:last-of-type {
        > div {
          .track {
            padding-bottom: 0;
          }
        }
      }

      &:nth-child(odd),
      &:nth-child(even) {
        > div {
          float: left;

          .track-dot {
            top: 0;
            left: 0;
            right: auto;
            height: 14px;
            width: 14px;
          }
        }
      }
    }

    .track {
      padding: 0 var(--spacing-16) var(--spacing-24) var(--spacing-40);
    }
  }
}

.track-line {
  background: var(--main-dark-shade-2);
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  overflow: hidden;
  z-index: 0;

  .track-line-filler {
    background-color: var(--accent);
    position: absolute;
    top: 2px;
    left: 0;
    width: 100%;
    height: 0;
    max-height: 100%;
  }

  + * {
    z-index: 1;
  }

  @include bp($bp-phone) {
    height: calc(100% - 20px);
    left: 0;
    transform: translate(30px, calc(-50% + 2px));

    .track-line-filler {
      top: -7px;
    }
  }
}

.track-button:not(.filled) {
  border-color: var(--main-dark-shade-2);
  background-color: var(--main-dark-shade-2);
  color: var(--main-dark-shade-0);
}

.start-learn-today {
  h2 {
    margin-top: 0;
    margin-bottom: var(--spacing-24);
  }

  p.body-1 {
    margin-bottom: var(--spacing-48);
  }
}

@include bp($bp-laptop) {
  ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
    max-width: 225px;
  }

  .table-wrap table tr td {
    padding: var(--spacing-20);
  }

  .physical-certificate-section {
    ::v-deep .hero-section-wrapper .container .row > div .subtitle {
      font-size: 18px;
    }
  }

  .tracker .track {
    padding: 0 var(--spacing-10);
  }
}

@include bp($bp-mobile) {
  .table-holder {
    position: relative;

    &:after {
      content: '';
      width: 36px;
      height: 100%;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0) 100%);
    }
  }

  .first-animation {
    background-color: var(--main-dark-shade-1);
    width: calc(100% + 48px);
    max-width: calc(100% + 48px);
    margin-left: -24px;
    display: inline-block;
  }

  .site-section:nth-of-type(2) .second-animation {
    margin-top: var(--spacing-40);
  }

  .track-button {
    width: 100%;
  }
}

.fa {
  @import '../assets/sass/fa/pages/career-track-certificate.scss';
}
</style>
